export const features = [
  {
    icon: 'ri-4k-line',
    title: '海量高清资源',
    description: '超过10万小时的高清视频内容库，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，每日持续更新500+条新鲜内容，满足各类观影需求。',
    color: 'primary',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅播放体验',
    description: '采用先进的P2P加速技术和全球CDN节点部署，智能码率自适应，即使在弱网环境下也能保障流畅的播放体验，告别卡顿和缓冲。',
    color: 'accent',
  },
  {
    icon: 'ri-ai-generate',
    title: '智能个性推荐',
    description: '基于深度学习算法的智能推荐引擎，精准分析您的观影偏好，深度挖掘潜在兴趣，越用越懂你，发现更多可能喜欢的内容。',
    color: 'secondary',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    description: '支持手机、平板、电脑等多设备同时登录使用，观看记录、收藏列表、播放进度实时云端同步，随时随地无缝切换继续观看。',
    color: 'primary',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存下载',
    description: '支持视频离线缓存功能，在WiFi环境下提前下载心仪内容，无需消耗流量即可随时随地观看，通勤旅途不无聊。',
    color: 'accent',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净体验',
    description: '严格的内容审核机制和家长控制功能，无恶意广告弹窗，为全家人提供安全、纯净的视频观看环境，放心使用。',
    color: 'secondary',
  },
];

export const stats = [
  { value: '5000万+', label: '累计用户', icon: 'ri-user-line' },
  { value: '10万+', label: '小时内容', icon: 'ri-film-line' },
  { value: '99.9%', label: '播放成功率', icon: 'ri-check-double-line' },
  { value: '4.8', label: '用户评分', icon: 'ri-star-line' },
];

export const faqs = [
  {
    question: '爱液视频App是免费的吗？',
    answer: '爱液视频App提供免费版和会员版两种选择。免费版可以观看大部分内容（含广告），会员版享受去广告、超清画质、独家内容等特权。新用户注册即送3天会员体验。',
  },
  {
    question: '如何在手机上安装爱液视频App？',
    answer: 'Android用户可在官网直接下载APK安装包，iOS用户在App Store搜索"爱液视频"下载。下载后按照提示完成安装即可。详细安装教程请查看我们的安装指南文章。',
  },
  {
    question: '爱液视频App支持哪些设备？',
    answer: '爱液视频App全面支持Android手机/平板（7.0及以上）、iPhone/iPad（iOS 13及以上）、Windows电脑和Mac电脑。同时支持智能电视和电视盒子安装使用。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '您可以尝试以下方法：1) 切换网络环境（WiFi/4G/5G）；2) 在播放设置中降低视频清晰度；3) 清理App缓存后重试；4) 检查手机是否有足够存储空间。如问题持续，请联系客服。',
  },
  {
    question: '如何取消会员自动续费？',
    answer: '在您购买会员时使用的支付平台（微信支付或支付宝）中，找到"免密支付/自动扣款"设置，取消爱液视频的自动续费授权即可。取消后不影响当前会员周期的使用。',
  },
  {
    question: '爱液视频App的内容多久更新一次？',
    answer: '我们每天24小时不间断更新内容，日均新增500+条视频。热门影视剧同步更新，综艺节目播出后2小时内上线，确保您第一时间观看到最新内容。',
  },
  {
    question: '可以多个设备同时登录一个账号吗？',
    answer: '免费账号支持2台设备同时在线，会员账号支持最多5台设备同时在线。家庭成员可以共享一个会员账号，各看各的互不影响。',
  },
  {
    question: '爱液视频App安全吗？会泄露隐私吗？',
    answer: '我们高度重视用户隐私安全。App采用银行级数据加密技术，严格遵守相关法律法规，承诺不向第三方出售或泄露用户个人信息。详细请查看我们的隐私政策。',
  },
];